export const initials = (name = "?") => name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

const COLORS = ["#e9714d", "#2f7d6d", "#3b6fb6", "#a0527d", "#c9962f", "#5a6b7d"];
const colorFor = (s = "") => COLORS[[...s].reduce((a, c) => a + c.charCodeAt(0), 0) % COLORS.length];

export function Avatar({ name, size = 28 }) {
  return <span className="pj-avatar" title={name} style={{ width: size, height: size, fontSize: size * 0.4, background: colorFor(name) }}>{initials(name)}</span>;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  if (diff < 7 * 86400) return `il y a ${Math.floor(diff / 86400)} j`;
  return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" });
}

export function MemberChecks({ members, value, onChange, testid }) {
  if (!members.length) return null;
  const all = members.every((m) => value.includes(m.id));
  const toggle = (id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  return (
    <div className="pj-notify" data-testid={testid}>
      <span>Notifier :</span>
      <label><input type="checkbox" checked={all} onChange={() => onChange(all ? [] : members.map((m) => m.id))} data-testid={`${testid}-all`} />Tout le monde</label>
      {members.map((m) => <label key={m.id}><input type="checkbox" checked={value.includes(m.id)} onChange={() => toggle(m.id)} data-testid={`${testid}-${m.id}`} />{m.name}</label>)}
    </div>
  );
}

export function RichText({ text, members = [] }) {
  const names = members.map((m) => m.name).filter(Boolean).sort((a, b) => b.length - a.length);
  if (!names.length) return <p className="pj-rich">{text}</p>;
  const re = new RegExp(`(@(?:${names.map((n) => n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")}))`, "gi");
  return <p className="pj-rich">{text.split(re).map((part, i) => (i % 2 ? <mark key={i} className="pj-mention">{part}</mark> : part))}</p>;
}
